import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Feedback Snackbar component for displaying success and error messages
 *
 * @param {Object} props - Component props
 * @param {boolean} props.success - Whether to show a success message
 * @param {string|null} props.error - Error message to display
 * @param {Function} props.onClose - Function to call when snackbar is closed
 * @returns {JSX.Element} The FeedbackSnackbar component
 */
const FeedbackSnackbar = ({ success, error, onClose }) => {
  const { t } = useTranslation('user');

  return (
    <>
      <Snackbar
        open={success}
        autoHideDuration={4000}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={onClose}
          severity="success"
          sx={{ width: '100%' }}
        >
          {t('forms.changesSaved')}
        </Alert>
      </Snackbar>

      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={onClose}
          severity="error"
          sx={{ width: '100%' }}
        >
          {error || t('forms.errorOccurred')}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FeedbackSnackbar;
